<template>
    <div class="home-version1">
      <div class='large-screen-wrap' :style="largeScreenStyle">
        <Header></Header>
        <div class="per-block">
          <LeftBlock></LeftBlock>
          <MiddleBlock></MiddleBlock>
          <RightBlock></RightBlock>
        </div>
      </div>
    </div>
  </template>

<script>
import Header from './components/Header/index.vue'
import LeftBlock from './components/leftBlock'
import MiddleBlock from './components/middleBlock'
import RightBlock from './components/rightBlock'
import {
  getScale,
  designHeight,
  designWidth
} from '@/utils/getScalc'
export default {
  data() {
    return {
      // 响应式变量
      designHeight,
      designWidth,
      scale: getScale(), // 初始化时候就进行一次获取比例
      timer: true // 防抖
    }
  },
  components: {
    Header,
    LeftBlock,
    MiddleBlock,
    RightBlock
  },
  computed: {
    largeScreenStyle() {
      return {
        transform: `scale(${this.scale[0]}, ${this.scale[1]}) translateX(-50%)`,
        height: `${this.designHeight}px`,
        width: `${this.scale[2]}px`
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.setScalc)
  },
  methods: {
    // 设置缩放比例
    setScalc() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.scale = getScale()
          // this.resize()
        }, 500)
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setScalc)
  }
}
</script>

  <style></style>
